var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content d-flex flex-column" },
    [
      _c(
        "Titlebar",
        { attrs: { incrustation: "fa-file", backPath: _vm.showBackBtn } },
        [_c("h1", [_vm._v(_vm._s(_vm.$t("reports.titles.list")))])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-1 relative d-flex flex-column",
          attrs: { id: "report-container" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "report-list-header px-3 d-flex align-items-center justify-content-between gap-1",
            },
            [
              _c(
                "UiButton",
                {
                  class: {
                    selected: _vm.selectedReport,
                    "btn-brand": _vm.selectorShow.report,
                  },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.showSelector("report")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "header-selector-inner truncate" }, [
                    _c("i", { staticClass: "fa fa-file mr-1" }),
                    _vm._v(
                      " " + _vm._s(_vm.selectedReportLabel) + "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiButton",
                {
                  class: {
                    selected: _vm.selectedResource,
                    "btn-brand": _vm.selectorShow.resource,
                    disabled: !_vm.hasResourcesSelection,
                  },
                  attrs: { disabled: !_vm.hasResourcesSelection },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.showSelector("resource")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "header-selector-inner truncate" }, [
                    _c("i", { staticClass: "fa fa-mobile-phone fa-lg mr-1" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.selectedResourceLabel) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiButton",
                {
                  class: {
                    selected: _vm.selectedPeriod.start.date,
                    "btn-brand": _vm.selectorShow.period,
                    disabled: !_vm.hasDateSelection,
                  },
                  attrs: { disabled: !_vm.hasDateSelection },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.showSelector("period")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "header-selector-inner truncate" }, [
                    _c("i", { staticClass: "fa fa-calendar mr-1" }),
                    _vm._v(
                      " " + _vm._s(_vm.selectedPeriodLabel) + "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiButton",
                {
                  staticClass: "primary",
                  class: { disabled: !_vm.isAllSelected },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.showReport($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("reports.btns.see")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative" }, [
            _vm.selectorShow.report
              ? _c("div", { staticClass: "report-list-selector show" }, [
                  _c("div", { staticClass: "cards-container p-2" }, [
                    _c(
                      "div",
                      { staticClass: "cards" },
                      [
                        _vm._l(_vm.reports, function (report) {
                          return _c(
                            "div",
                            {
                              key: report.slug,
                              staticClass: "card-item",
                              on: {
                                click: function ($event) {
                                  return _vm.selectReport(report, "html")
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card report-card",
                                  class: {
                                    selected:
                                      _vm.selectedReportId == report.id &&
                                      _vm.canSelect(report.slug),
                                    "licence-offer-difference":
                                      (report.slug == "ppes" &&
                                        !_vm.canSelect(report.slug)) ||
                                      (report.slug == "actionpoint" &&
                                        !_vm.canSelect(report.slug)),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "div",
                                      { staticClass: "icon text-center" },
                                      [_c("i", { class: report.icon })]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "infos" }, [
                                      _c("h3", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "reports.reports." +
                                                  report.slug +
                                                  ".title"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "reports.reports." +
                                                  report.slug +
                                                  ".description"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-footer" },
                                    [
                                      _vm._l(report.output, function (output) {
                                        return _c(
                                          "span",
                                          {
                                            staticClass: "badge",
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectReport(
                                                  report,
                                                  output
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(output))]
                                        )
                                      }),
                                      _vm._v(" "),
                                      (report.slug == "ppes" &&
                                        !_vm.canSelect(report.slug)) ||
                                      (report.slug == "actionpoint" &&
                                        !_vm.canSelect(report.slug))
                                        ? _c(
                                            "span",
                                            { staticStyle: { float: "right" } },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-info-circle text-dark warning-beepiz-remote-monitoring show",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "tooltip top",
                                                  staticStyle: {
                                                    width: "80%",
                                                    right: "60px",
                                                    top: "0px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticStyle: {
                                                        color: "#ffc107",
                                                        "font-weight": "700",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.reports." +
                                                                report.slug +
                                                                ".infoTitle"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "reports.reports." +
                                                            report.slug +
                                                            ".infoBody"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-lock text-dark warning-beepiz-remote-monitoring show",
                                                staticStyle: {
                                                  "padding-left": "5px",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "tooltip top",
                                                  staticStyle: {
                                                    width: "80%",
                                                    right: "60px",
                                                    top: "0px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "700",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Disponible à partir de l'offre Premium\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticStyle: {
                                                      width: "45px",
                                                      height: "45px",
                                                      display: "block",
                                                      "text-align": "center",
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.pictoPremium
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm._m(0, true),
                                ]
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "card-item",
                            attrs: { to: "/reports/platform?history=licence" },
                          },
                          [
                            _c("div", { staticClass: "card report-card" }, [
                              _c("div", { staticClass: "icon text-center" }, [
                                _c("i", { staticClass: "fa fa-newspaper-o" }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infos" }, [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(_vm.$t("reports.reports.logs.title"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("reports.reports.logs.description")
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "card-footer" }, [
                                _c("span", { staticClass: "badge" }, [
                                  _vm._v("XLS"),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectorShow.resource
              ? _c("div", { staticClass: "report-list-selector show" }, [
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.selectedReport,
                                expression: "!selectedReport",
                              },
                            ],
                            staticClass: "required-report",
                            domProps: {
                              innerHTML: _vm._s(_vm.$tc("reports.reportFirst")),
                            },
                          }),
                          _vm._v(" "),
                          _c("ResourceSelector", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.selectedReport,
                                expression: "selectedReport",
                              },
                            ],
                            attrs: {
                              config: _vm.getSelectedReportResourcesConfig,
                              preselected:
                                _vm.getSelectedReportResourcesPreSelection,
                            },
                            on: { change: _vm.handleChangeResourcesSelection },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectorShow.period
              ? _c("div", { staticClass: "report-list-selector show" }, [
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.selectedReport,
                              expression: "!selectedReport",
                            },
                          ],
                          staticClass: "required-report",
                          domProps: {
                            innerHTML: _vm._s(_vm.$tc("reports.reportFirst")),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedReport,
                              expression: "selectedReport",
                            },
                          ],
                          staticClass: "col-8 offset-2",
                          staticStyle: { "text-align": "center" },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("global.fromToDate1"))),
                          ]),
                          _vm._v(" "),
                          _c("DatePicker", {
                            attrs: {
                              min: _vm.availablePeriod.start.date,
                              max: _vm.availablePeriod.end.date,
                            },
                            model: {
                              value: _vm.selectedPeriod.start.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedPeriod.start, "date", $$v)
                              },
                              expression: "selectedPeriod.start.date",
                            },
                          }),
                          _vm._v(" "),
                          _c("ClockPicker", {
                            model: {
                              value: _vm.selectedPeriod.start.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedPeriod.start, "time", $$v)
                              },
                              expression: "selectedPeriod.start.time",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("global.fromToDate2"))),
                          ]),
                          _vm._v(" "),
                          _c("DatePicker", {
                            attrs: {
                              min: _vm.availablePeriod.start.date,
                              max: _vm.availablePeriod.end.date,
                            },
                            model: {
                              value: _vm.selectedPeriod.end.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedPeriod.end, "date", $$v)
                              },
                              expression: "selectedPeriod.end.date",
                            },
                          }),
                          _vm._v(" "),
                          _c("ClockPicker", {
                            model: {
                              value: _vm.selectedPeriod.end.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedPeriod.end, "time", $$v)
                              },
                              expression: "selectedPeriod.end.time",
                            },
                          }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          !_vm.isValidPeriod
                            ? _c("div", { staticClass: "duration-error" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$tc(
                                        "reports.invalidPeriod",
                                        _vm.getSelectedNumberOfDays,
                                        {
                                          count: _vm.getSelectedNumberOfDays,
                                        }
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedReport,
                              expression: "selectedReport",
                            },
                          ],
                          staticClass: "col-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-column" },
                            [
                              _vm.isOneDay
                                ? _c(
                                    "UiButton",
                                    {
                                      attrs: { block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setDates("today")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("reports.shortLinks.today")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isOneDay
                                ? _c(
                                    "UiButton",
                                    {
                                      attrs: { block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setDates("yesterday")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "reports.shortLinks.yesterday"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isOneWeek
                                ? _c(
                                    "UiButton",
                                    {
                                      attrs: { block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setDates("thisweek")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "reports.shortLinks.thisweek"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isOneWeek
                                ? _c(
                                    "UiButton",
                                    {
                                      attrs: { block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setDates("lastweek")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "reports.shortLinks.lastweek"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isOneMonth
                                ? _c(
                                    "UiButton",
                                    {
                                      attrs: { block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setDates("thismonth")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "reports.shortLinks.thismonth"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isOneMonth
                                ? _c(
                                    "UiButton",
                                    {
                                      attrs: { block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setDates("lastmonth")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "reports.shortLinks.lastmonth"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isOneMonth
                                ? _c(
                                    "UiButton",
                                    {
                                      attrs: { block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setDates("last30days")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "reports.shortLinks.last30days"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.result,
                  expression: "!result",
                },
              ],
              staticClass: "report-placeholder flex-1",
            },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("reports.placeholder.first")))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("reports.placeholder.second"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("reports.placeholder.report")),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showSelector("report")
                    },
                  },
                }),
                _vm._v(",\n        "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("reports.placeholder.resource")),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showSelector("resource")
                    },
                  },
                }),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("global.and")) + "\n        "
                ),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("reports.placeholder.period")),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showSelector("period")
                    },
                  },
                }),
                _vm._v(".\n      "),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("iframe", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.result,
                expression: "result",
              },
            ],
            ref: "reportResult",
            staticClass: "flex-1 border",
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "absolute right-3 bottom-3" },
            [
              _vm.selectedReportOutputs.length > 1 &&
              _vm.useDvFlagAccess("beepiz-report-can:export")
                ? _c(
                    "Btn",
                    {
                      class: [
                        {
                          "no-hover": _vm.showActionsDL,
                          disabled: !_vm.isAllSelected || _vm.lockDLBtn,
                        },
                        "default",
                      ],
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleActionsDL($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "on-clickaway",
                              rawName: "v-on-clickaway",
                              value: _vm.closeActionsDL,
                              expression: "closeActionsDL",
                            },
                          ],
                          staticClass: "button-actions",
                          class: { show: _vm.showActionsDL },
                        },
                        [
                          _c(
                            "ul",
                            _vm._l(
                              _vm.selectedReportOutputs,
                              function (output) {
                                return _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.dlReport(output)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm._f("uppercase")(output)) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-caret-up" }),
                      _vm._v(" "),
                      _c("span", [
                        _c("i", { staticClass: "fa fa-download" }),
                        _vm._v("   " + _vm._s(_vm.$t("global.download"))),
                      ]),
                      _vm._v(" "),
                      _c("LoadingMini", { ref: "loading" }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedReportOutputs.length == 1 &&
              _vm.useDvFlagAccess("beepiz-report-can:export")
                ? _c(
                    "Btn",
                    {
                      staticClass: "default pull-left",
                      class: { disabled: !_vm.isAllSelected || _vm.lockDLBtn },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.dlReport(_vm.selectedReportOutputs[0])
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-download" }),
                      _vm._v(
                        "   " + _vm._s(_vm.$t("global.download")) + "\n        "
                      ),
                      _c("LoadingMini", { ref: "loading" }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "select-marker" }, [
      _c("i", { staticClass: "fa fa-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }